import React, { useEffect, useState, useRef } from 'react';
import propTypes from 'prop-types';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { setBreadcrumbs, InnerLoader } from 'src/ui';
import {
  fetchLoginHistory,
  fetchLoggedInUser,
  getUser,
  getLoginHistory,
} from 'src/user';
import { getToken } from 'src/auth';
import { connect } from 'react-redux';
import { fetchAccount, getAccount } from 'src/account';
import moment from 'moment';
import { LoginHistoryTable } from '../../user/components';
import DatePicker from 'react-datepicker';

function LoginHistoryPage({
  user,
  token,
  fetchLoginHistory,
  loginHistory,
  setBreadcrumbs,
}) {
  const now = new Date();
  const today = moment(
    new Date(now.getFullYear(), now.getMonth(), now.getDate())
  );
  const startDate = today.clone().subtract(14, 'days');
  const endDate = today.clone().endOf('day');
  const [dateRange, setDateRange] = React.useState([
    startDate.toDate(),
    endDate.toDate(),
  ]);
  const [loading, setLoading] = useState(true);

  const onDateRangeChange = (start, end) => {
    setDateRange([
      moment(start)
        .startOf('day')
        .toDate(),
      moment(end)
        .endOf('day')
        .toDate(),
    ]);
  };
  const isFirstRun = useRef(0);
  useEffect(() => {
    (async () => {
      isFirstRun.current += 1;

      setBreadcrumbs([{ label: 'Login History', href: '/login-history' }]);
      if (token.isValid()) {
        await fetchLoginHistory({
          financialInstitutionId: user.financialInstitutionId,
          start: moment.utc(dateRange[0]).format(),
          end: moment.utc(dateRange[1]).format(),
        });
        setLoading(false);
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      isFirstRun.current += 1;
      setLoading(true);
      if (isFirstRun.current > 2) {
        await fetchLoginHistory({
          financialInstitutionId: user.financialInstitutionId,
          start: moment.utc(dateRange[0]).format(),
          end: moment.utc(dateRange[1]).format(),
        });
      }

      if (!loginHistory.isLoading()) {
        setLoading(false);
      }
    })();
  }, [dateRange]);
  return (
    <>
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Login History
          </MuiTitle>
        </Column>
        <Column>
          <div className="is-pulled-right">
            <div className="date-range-picker" style={{ display: 'flex' }}>
              <DatePicker
                selected={dateRange[0]}
                onChange={date => onDateRangeChange(date, dateRange[1])}
                selectsStart
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                className="input"
                wrapperClassName="date-picker-wrapper"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              <DatePicker
                selected={dateRange[1]}
                onChange={date => onDateRangeChange(dateRange[0], date)}
                selectsEnd
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                minDate={dateRange[0]}
                className="input"
                wrapperClassName="date-picker-wrapper"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
          </div>
        </Column>
      </Columns>
      {!loading && !loginHistory.isLoading() ? (
        <InnerLoginHistoryPage
          data={loginHistory.loginHistory}
          loading={loading}
        />
      ) : (
        <InnerLoader visible />
      )}
    </>
  );
}
function InnerLoginHistoryPage({ data, loading }) {
  return (
    <>
      <LoginHistoryTable data={data} loading={loading} />
    </>
  );
}
function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    account: getAccount(state),
    loginHistory: getLoginHistory(state),
  };
}
LoginHistoryPage.propTypes = {
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchLoginHistory: propTypes.func.isRequired,
  loginHistory: propTypes.object.isRequired,
};

InnerLoginHistoryPage.propTypes = {
  data: propTypes.array.isRequired,
  loading: propTypes.bool.isRequired,
};
const connectedLoginHistoryPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchLoginHistory,
  fetchLoggedInUser,
  fetchAccount,
})(LoginHistoryPage);

export { connectedLoginHistoryPage as LoginHistoryPage };
